import { ChevronDown } from "lucide-react";
import { useChartStore } from "@/stores/chartStore";
import { useUIStore } from "@/stores/uiStore";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function SymbolTicker() {
  const symbol = useChartStore((s) => s.symbol);
  const openModal = useUIStore((s) => s.openModal);

  const displayName = symbol || "—";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => openModal("symbolSearch")}
          id="symbol-ticker-btn"
          aria-label="Switch symbol"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            height: 30,
            padding: "0 12px",
            borderRadius: "var(--radius-md)",
            border: "1px solid var(--lyt-border-default)",
            background: "var(--lyt-bg-elevated)",
            cursor: "pointer",
            transition: "border-color 120ms ease, background 120ms ease",
            flexShrink: 0,
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.borderColor = "var(--lyt-border-strong)";
            (e.currentTarget as HTMLButtonElement).style.background = "var(--lyt-bg-overlay)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.borderColor = "var(--lyt-border-default)";
            (e.currentTarget as HTMLButtonElement).style.background = "var(--lyt-bg-elevated)";
          }}
        >
          <span
            style={{
              fontFamily: "var(--font-ui)",
              fontSize: "var(--text-md)",
              fontWeight: 600,
              color: "var(--lyt-text-primary)",
              letterSpacing: "-0.01em",
              whiteSpace: "nowrap",
            }}
          >
            {displayName}
          </span>

          <ChevronDown
            style={{
              width: 11,
              height: 11,
              color: "var(--lyt-text-muted)",
              flexShrink: 0,
            }}
            strokeWidth={2.5}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" sideOffset={8}>
        Switch symbol — type any letter
      </TooltipContent>
    </Tooltip>
  );
}
